import { api, apiUrl } from "../shared/services/service";

export type AppearanceTheme = "bright" | "night";

type ThemePreferenceResponse = {
  theme?: unknown;
};

export const isAppearanceTheme = (value: unknown): value is AppearanceTheme => value === "bright" || value === "night";

export const themePreferenceToDarkMode = (theme: AppearanceTheme) => theme === "night";

export const darkModeToThemePreference = (isDarkMode: boolean): AppearanceTheme => (isDarkMode ? "night" : "bright");

export async function getThemePreference(): Promise<AppearanceTheme> {
  const result = await api.get<ThemePreferenceResponse>(`${apiUrl}/user-prefs/theme`);
  return isAppearanceTheme(result.data.theme) ? result.data.theme : "bright";
}

export async function saveThemePreference(theme: AppearanceTheme): Promise<void> {
  await api.put(`${apiUrl}/user-prefs/theme`, { theme });
}
